import makeApiCall from "../master/axiosIndex";

const workOrderApis = {
  getWorkOrderList: (params: any) =>
    makeApiCall({
      url: `/work-order/list`,
      method: "get",
      params,
    }),
  getPendingApprovalsWorkOrderList: (params: any) =>
    makeApiCall({
      url: `/work-order/pending-approvals`,
      method: "get",
      params,
    }),
  createWorkOrder: (data: any) =>
    makeApiCall({
      url: `/work-order/create`,
      method: "post",
      data,
    }),
  getWorkOrderById: (workOrderId: any) =>
    makeApiCall({
      url: `/work-order/id/${workOrderId}`,
      method: "get",
    }),
  updateWorkOrder: (data: any) =>
    makeApiCall({
      url: `/work-order/update`,
      method: "put",
      data,
    }),
  contractorChangeRequest: (data: any) =>
    makeApiCall({
      url: `/work-order/contractor-change-request`,
      method: "post",
      data,
    }),
  confirmByContractor: (data: any) =>
    makeApiCall({
      url: `/work-order/confirm-by-contractor`,
      method: "post",
      data,
    }),
};

export default workOrderApis;
